import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Shortcutter from 'mixins/shortcuts';
import { Menu, MenuItem } from 'react-toolbox/lib/menu';
import { Button } from 'react-toolbox/lib/button';
import { visibleFor } from 'components/Auth';
import AddCommunicationModal from 'addCommunicationModal';
import AddNoteModal from 'addNoteModal';
import AddContractorNoteModal from 'addContractorNoteModal';
import SetDueTomorrowModal from 'setDueTomorrowModal';
import CancelPhaseModal from 'cancelPhaseModal';
import AddFlagModal from 'addFlagModal';
import AssignEstimatorModal from 'assignEstimatorModal';
import AssignInstallerModal from '../assignInstallerModal';
import WorkorderModal from 'workorderModal';
import CheckinModal from 'checkinModal';
import CreateExceptionModal from 'createExceptionModal';
import CocModal from 'cocModal';
import WalkthroughModal from '../tasks/components/WalkthroughModal';
import RepairInspectionModal from 'repairInspectionModal';
import CrewInspectionModal from 'crewInspectionModal';
import PrintInstallerPaperworkModal from 'printInstallerPaperworkModal';
import { navigate, requestPhaseItems } from 'actionCreators';
import { createPhaseItem } from 'actionCreators/phase_items';
import SendToFloorWizardModal from 'sendToFloorWizardModal';
import IfiLrrpModal from './ifiLrrpModal.jsx';
import QuickScheduleModal from './quickScheduleModal.jsx';
import CustomLaborSheetModal from './customLaborSheetModal';
import CreateSupportRequestModal from '../createSupportRequestModal';
import PhaseType from 'types/phase';
import cx from 'classnames';
import styles from './styles.scss';
import composeWindowStyles from 'components/ComposeWindow/styles.scss';
import { roleNotInstallerBased } from '../../../../../../../utils';
import { connect } from 'react-redux';
import isIfiPhase from '../ifiUtils';
import { urls } from 'helpers/url';
// Hiding Add Installer Pay button in case it required again
import { can, canAccessCustomLaborSheet, canAccessIfiTemplate } from '../../../../../../../services';
import { normalizePayRateLineItemOptions } from '../../../../../../../utils/lineItemUtils';

const CancelPhaseItem = visibleFor('cancel', 'phase', ({ onClick, disabled }) =>
  <MenuItem
    className={styles.item}
    caption="Cancel Phase"
    onClick={onClick}
    disabled={disabled}
  />,
);

/**
 * We get PropType errors due to passing jsx tags as captions.
 * The caption prop expects a string only. We might need to
 * figure out a different approach for these, or ignore the
 * errors, but this is why they happen.
 */

const CreateFlagItem = ({ onClick }) => (
  <MenuItem
    className={styles.item}
    caption={<span>Add <u>F</u>lag</span>}
    onClick={onClick}
  />
);

const CreateEventItem = visibleFor('create', 'event', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const UpdateContractorNotePhaseItem = visibleFor('update_contractor_notes', 'phase', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const AssignPhaseItem = visibleFor('assign', 'estimator', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const AssignInstallerItem = visibleFor('assign', 'installer', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const CreateWorkorderItem = visibleFor('copy', 'phase', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const CreateExceptionItem = visibleFor('update', 'create_exception', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const CreateWalkthroughItem = visibleFor('update', 'walkthrough', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const CreateRepairInspectionItem = visibleFor('update', 'repair_inspection_report', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const CreateCrewInspectionItem = visibleFor('update', 'crew_inspection', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

const InstallationsPaperworkItem = visibleFor('view', 'installations_paperwork', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

// Hiding Add Installer Pay button in case it required again
// const AddInstallerPayItem = visibleFor('view', 'accounting', ({ label, onClick, disabled }) =>
//   <MenuItem
//     className={styles.item}
//     caption={label}
//     onClick={onClick}
//     disabled={disabled}
//   />,
// );

const SendToFloorWizardItem = visibleFor('update', 'floor_wizard', ({ label, onClick }) =>
  <MenuItem
    className={styles.item}
    caption={label}
    onClick={onClick}
  />,
);

class PhaseActionMenu extends Shortcutter(React.Component, [
  { key: 'c', func: 'handleContractorNoteShortcut' },
  { key: 'f', func: 'handleFlagShortcut' },
  { key: 'a', func: 'handleCommunicationShortcut' },
]) {
  state = { menuActive: false, active: [] }

  componentWillMount = () =>
    this.props.requestPhaseItems(this.props.phase.id, 'contractorLineItems');

  handleClick = target => this.setState({
    menuActive: false,
    active: [...this.state.active, target],
  });

  handleShortcut = (target, e) => {
    e.preventDefault();
    this.handleClick(target);
  }

  handleClose = target => this.setState({
    active: this.state.active.filter(a => a !== target),
  });

  handleNoteClick = this.handleClick.bind(this, 'note')
  handleNoteClose = this.handleClose.bind(this, 'note')
  handleContractorNoteClick = this.handleClick.bind(this, 'contractor_notes')
  handleContractorNoteShortcut = this.handleShortcut.bind(this, 'contractor_notes')
  handleContractorNoteClose = this.handleClose.bind(this, 'contractor_notes')
  handleCommunicationClick = this.handleClick.bind(this, 'communication')
  handleSetDueTomorrowClick = this.handleClick.bind(this, 'set_due_tomorrow')
  handleSetDueTomorrowClose = this.handleClose.bind(this, 'set_due_tomorrow')
  handleCommunicationShortcut = this.handleShortcut.bind(this, 'communication')
  handleCommunicationClose = this.handleClose.bind(this, 'communication')
  handleFlagClick = this.handleClick.bind(this, 'flag')
  handleFlagShortcut = this.handleShortcut.bind(this, 'flag')
  handleFlagClose = this.handleClose.bind(this, 'flag')
  handleStatusClick = this.handleClick.bind(this, 'status')
  handleStatusClose = this.handleClose.bind(this, 'status')
  handleCancelClick = this.handleClick.bind(this, 'cancel')
  handleCancelClose = this.handleClose.bind(this, 'cancel')
  handleAssignClick = this.handleClick.bind(this, 'assign_estimator')
  handleAssignClose = this.handleClose.bind(this, 'assign_estimator')
  handleInstallerAssignClick = this.handleClick.bind(this, 'assign_installer')
  handleInstallerAssignClose = this.handleClose.bind(this, 'assign_installer')
  handleWorkorderClick = this.handleClick.bind(this, 'workorder')
  handleWorkorderClose = this.handleClose.bind(this, 'workorder')
  handleCheckInClick = this.handleClick.bind(this, 'checkin')
  handleCheckinClose = this.handleClose.bind(this, 'checkin')
  handleCreateExceptionClick = this.handleClick.bind(this, 'create_exception')
  handleCreateExceptionClose = this.handleClose.bind(this, 'create_exception')
  handleCOCClick = this.handleClick.bind(this, 'coc')
  handleCOCClose = this.handleClose.bind(this, 'coc')
  handleWalkThroughClick = this.handleClick.bind(this, 'walkthrough')
  handleWalkThroughClose = this.handleClose.bind(this, 'walkthrough')
  handleRepairInspectionClick = this.handleClick.bind(this, 'repair_inspection_report')
  handleRepairInspectionClose = this.handleClose.bind(this, 'repair_inspection_report')
  handleCrewInspectionClick = this.handleClick.bind(this, 'crew_inspection')
  handleCrewInspectionClose = this.handleClose.bind(this, 'crew_inspection')
  handlePaperworkClick = this.handleClick.bind(this, 'paperwork')
  handlePaperworkClose = this.handleClose.bind(this, 'paperwork')
  handleFloorWizardClick = this.handleClick.bind(this, 'floor_wizard');
  handleFloorWizardClose = this.handleClose.bind(this, 'floor_wizard')
  handleIfiLrrpClick = this.handleClick.bind(this, 'ifi_lrrp')
  handleIfiLrrpClose = this.handleClose.bind(this, 'ifi_lrrp')
  handleIfiTemplateNavigate = () => {
    this.handleMenuHide();
    this.props.navigate(urls.phaseIfiTemplate(this.props.phase));
  };
  handleCustomLaborSheetClick = this.handleClick.bind(this, 'custom_labor_sheet')
  handleCustomLaborSheetClose = this.handleClose.bind(this, 'custom_labor_sheet')
  handleQuickScheduleClick = this.handleClick.bind(this, 'quick_schedule')
  handleQuickScheduleClose = this.handleClose.bind(this, 'quick_schedule')
  handleSupportRequestClick = this.handleClick.bind(this, 'support_request')
  handleSupportRequestClose = this.handleClose.bind(this, 'support_request')

  handleButtonClick = () => this.setState({ menuActive: !this.state.menuActive });

  handleMenuHide = () => this.setState({ menuActive: false });

  handleAddInstallerPay = () => {
    this.handleMenuHide();
    this.props.navigate(`/phases/${this.props.phase.id}/labor-product-accounting/walkthrough`);
    setTimeout(() => document.getElementById('tutorialRestartBtn').click(), 1000);
  };

  disableAddInstallerPay = (laborSheets) => {
    const editableSheets = laborSheets.filter(sheet => sheet.id > 0 && sheet.status === 'Pending Review');
    return editableSheets.length < 1;
  }

  canAccessIfiLrrp = () => {
    const { phase, role, position, mvw, employableId } = this.props;
    if (!isIfiPhase(phase)) return false;

    return can(role, 'manage', 'ifi_lrrp', {
      position,
      mvw,
      phase_installer_id: phase.installer_id,
      employable_id: employableId,
    });
  }

  canQuickSchedule = () => {
    const { phase, role, employableId, isSelfSchedulable } = this.props;
    if (!isIfiPhase(phase)) return false;
    if (phase.pending_quick_schedule_response) return false;

    return can(role, 'quick_schedule', 'PHASE', {
      source: phase.source,
      phase_type: phase.type,
      phase_estimator_id: phase.estimator_id,
      phase_installer_id: phase.installer_id,
      employable_id: employableId,
      is_self_schedulable: isSelfSchedulable,
    });
  }

  canCreateSupportRequest = () => {
    const { role } = this.props;
    return can(role, 'create', 'support_request');
  }

  canCreateIfiTemplate = () => {
    const { phase, role } = this.props;
    return canAccessIfiTemplate({ role, phase_type: phase.type, phase_source: phase.source });
  }

  flagPermissionCheck = () => {
    const { phase, role, position, mvw, employableId } = this.props;

    if (role === 'installer') {
      return can(role, 'create', 'flag', {
        position,
        mvw,
        phase_installer_id: phase.installer_id,
        employable_id: employableId,
      });
    }
    return can(role, 'create', 'flag');
  };

  render = () => {
    // Hiding Add Installer Pay button in case it required again
    // eslint-disable-next-line no-unused-vars
    const { phase, role, laborSheets, contractorTableApproved, position, mvw } = this.props;
    const status = phase.status;
    const { menuActive, active } = this.state;
    const canCreateFlag = this.flagPermissionCheck();
    const canCreateIfiLrrp = this.canAccessIfiLrrp();
    const canQuickSchedule = this.canQuickSchedule();
    const canCreateSupportRequest = this.canCreateSupportRequest();
    const canCreateIfiTemplate = this.canCreateIfiTemplate();
    const canCreateCustomLaborSheet = canAccessCustomLaborSheet({
      role,
      phase_source: phase.source,
      mvw,
    });
    return (<div>
      <div className={cx(styles.container, { [styles.isComposeOpen]: active.length })}>
        <Button
          theme={styles}
          icon="add"
          floating ripple primary
          onClick={this.handleButtonClick}
        />
        <Menu
          active={menuActive}
          onHide={this.handleMenuHide}
          position="bottomRight"
          ripple
        >
          {roleNotInstallerBased(role) && role !== 'estimator' && <MenuItem
            className={styles.item}
            caption="Due Tomorrow"
            onClick={this.handleSetDueTomorrowClick}
          />}
          {status !== 'canceled' && <CancelPhaseItem
            onClick={this.handleCancelClick}
            label="Cancel Phase"
          />}
          {canCreateFlag && <CreateFlagItem onClick={this.handleFlagClick} />}
          {can(role, 'override', 'phase') && (
            <CreateEventItem
              label={<span><u>A</u>dd Communication</span>}
              onClick={this.handleCommunicationClick}
            />
          )}
          {role === 'installer' && <CreateEventItem
            label="Check In/Out"
            onClick={this.handleCheckInClick}
          />}
          {canCreateCustomLaborSheet && (
            <MenuItem
              className={styles.item}
              caption="Custom Labor Sheet"
              onClick={this.handleCustomLaborSheetClick}
            />
          )}
          {/* Hiding Add Installer Pay button in case it required again */}
          {/* {phase.appointments && phase.appointments.length > 0 &&
           can(role, 'update', 'contractor_line_item') &&
           contractorTableApproved && <AddInstallerPayItem
             label="Add Installer Pay"
             onClick={this.handleAddInstallerPay}
             disabled={this.disableAddInstallerPay(laborSheets)}
           />
          } */}
          <UpdateContractorNotePhaseItem
            label={<span><u>C</u>ontractor Notes</span>}
            onClick={this.handleContractorNoteClick}
          />
          {['installer', 'estimator'].includes(role) && <CreateEventItem
            label={<span>Add <u>N</u>ote</span>}
            onClick={this.handleNoteClick}
          />}
          {phase.type === 'Assessment' && <Fragment>
            <AssignPhaseItem
              label="Assign Estimator"
              onClick={this.handleAssignClick}
            />
            {!phase.rocky_managed && <SendToFloorWizardItem
              label="Send Phase To Floor Wizard"
              onClick={this.handleFloorWizardClick}
            />}
          </Fragment>}
          {phase.source === 'IFI' && can(role, 'manage', 'assign_installer', { position, mvw }) && <AssignInstallerItem
            label="Assign Installer"
            onClick={this.handleInstallerAssignClick}
          />
          }
          {roleNotInstallerBased(role) && <CreateExceptionItem
            label="Create Exception"
            onClick={this.handleCreateExceptionClick}
          />}
          <CreateWorkorderItem
            label="Create Workorder"
            onClick={this.handleWorkorderClick}
          />
          {phase.type === 'Installation' && <CreateWalkthroughItem
            label="Walkthrough Forms"
            onClick={this.handleWalkThroughClick}
          />}
          {phase.type !== 'Assessment' && roleNotInstallerBased(role) && <Fragment>
            <CreateCrewInspectionItem
              label="Crew Inspection"
              onClick={this.handleCrewInspectionClick}
            />
            {phase.type === 'Workorder' && phase.source !== 'IFI' && <CreateRepairInspectionItem
              label="Workorder Inspection"
              onClick={this.handleRepairInspectionClick}
            />}
          </Fragment>}
          {phase.type !== 'Assessment' && <InstallationsPaperworkItem
            label="Preview Paperwork"
            onClick={this.handlePaperworkClick}
          />}
          {canCreateIfiLrrp && <MenuItem
            className={styles.item}
            caption="Create IFI LRRP"
            onClick={this.handleIfiLrrpClick}
          />}
          {canCreateIfiTemplate && (
            <MenuItem
              className={styles.item}
              caption="IFI Template"
              onClick={this.handleIfiTemplateNavigate}
            />
          )}
          {canQuickSchedule && <MenuItem
            className={styles.item}
            caption="Quick Schedule"
            onClick={this.handleQuickScheduleClick}
          />}
          {canCreateSupportRequest && <MenuItem
            className={styles.item}
            caption="Create Support Request"
            onClick={this.handleSupportRequestClick}
          />}
        </Menu>
      </div>
      <div className={composeWindowStyles.container}>
        <AddNoteModal
          phase={phase}
          active={active.includes('note')}
          onClose={this.handleNoteClose}
        />
        <AddContractorNoteModal
          phase={phase}
          active={active.includes('contractor_notes')}
          onClose={this.handleContractorNoteClose}
        />
        <AddCommunicationModal
          phase={phase}
          active={active.includes('communication')}
          onClose={this.handleCommunicationClose}
        />
        <AddFlagModal
          phase={phase}
          active={active.includes('flag')}
          onClose={this.handleFlagClose}
        />
        <CreateSupportRequestModal
          phase={phase}
          active={active.includes('support_request')}
          onClose={this.handleSupportRequestClose}
        />
      </div>
      <SetDueTomorrowModal
        phase={phase}
        active={active.includes('set_due_tomorrow')}
        onClose={this.handleSetDueTomorrowClose}
      />
      <CancelPhaseModal
        phase={phase}
        active={active.includes('cancel')}
        onClose={this.handleCancelClose}
      />
      <AssignEstimatorModal
        phase={phase}
        active={active.includes('assign_estimator')}
        onClose={this.handleAssignClose}
      />
      <AssignInstallerModal
        phase={phase}
        active={active.includes('assign_installer')}
        onClose={this.handleInstallerAssignClose}
      />
      <WorkorderModal
        phase={phase}
        active={active.includes('workorder')}
        onClose={this.handleWorkorderClose}
      />
      <CheckinModal
        phase={phase}
        active={active.includes('checkin')}
        onClose={this.handleCheckinClose}
      />
      <CreateExceptionModal
        phase={phase}
        active={active.includes('create_exception')}
        onClose={this.handleCreateExceptionClose}
      />
      <CocModal
        phase={phase}
        active={active.includes('coc')}
        onClose={this.handleCOCClose}
      />
      <WalkthroughModal
        phase={phase}
        active={active.includes('walkthrough')}
        onClose={this.handleWalkThroughClose}
      />
      <RepairInspectionModal
        phase={phase}
        active={active.includes('repair_inspection_report')}
        onClose={this.handleRepairInspectionClose}
      />
      <CrewInspectionModal
        phase={phase}
        active={active.includes('crew_inspection')}
        onClose={this.handleCrewInspectionClose}
      />
      <PrintInstallerPaperworkModal
        active={active.includes('paperwork')}
        onClose={this.handlePaperworkClose}
        selectInstaller
        phaseId={phase.id}
        role={role}
      />
      <SendToFloorWizardModal
        active={active.includes('floor_wizard')}
        onClose={this.handleFloorWizardClose}
        phaseId={phase.id}
      />
      <IfiLrrpModal
        phase={phase}
        active={active.includes('ifi_lrrp')}
        onClose={this.handleIfiLrrpClose}
      />
      <QuickScheduleModal
        phase={phase}
        active={active.includes('quick_schedule')}
        onClose={this.handleQuickScheduleClose}
      />
      <CustomLaborSheetModal
        active={active.includes('custom_labor_sheet')}
        onClose={this.handleCustomLaborSheetClose}
        phase={phase}
        laborSheets={laborSheets}
        lineItemOptions={this.props.lineItemOptions}
        createPhaseItem={this.props.createPhaseItem}
        navigate={this.props.navigate}
      />
    </div>);
  }
}

PhaseActionMenu.propTypes = {
  phase: PhaseType.isRequired,
  role: PropTypes.string.isRequired,
  navigate: PropTypes.func,
  location: PropTypes.object,
  laborSheets: PropTypes.array,
  lineItemOptions: PropTypes.array,
  contractorTableApproved: PropTypes.bool,
  requestPhaseItems: PropTypes.func.isRequired,
  createPhaseItem: PropTypes.func.isRequired,
  position: PropTypes.string.isRequired,
  mvw: PropTypes.shape({
    ifi: PropTypes.bool,
  }).isRequired,
  employableId: PropTypes.number,
  isSelfSchedulable: PropTypes.bool,
};

CreateFlagItem.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { user, employees } = state;
  const employableType = state.user.employable_type.toLowerCase() || '';
  const contractorTableApproved = employableType === 'employee' ?
    (employees.byId[user.employable_id] || {}).contractor_table_approved || false : false;
  const laborSheets = state.phase.laborSheets.items;
  return {
    laborSheets,
    lineItemOptions: normalizePayRateLineItemOptions(state.payRateLineItems.data, laborSheets),
    contractorTableApproved,
    position: user.position,
    mvw: user.manage_vendor_workrooms || {},
    employableId: state.user.employable_id,
    isSelfSchedulable: !!state.user.is_self_schedulable,
  };
};

export default connect(
  mapStateToProps,
  { navigate, requestPhaseItems, createPhaseItem },
)(PhaseActionMenu);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/index.jsx